<script setup lang="ts">
import NotificationItem from './NotificationItem.vue'
import { useNotificationState } from '../../utilities/useNotifications'

const notificationStore = useNotificationState()
</script>

<template>
    <div
        aria-live="assertive"
        class="pointer-events-none fixed inset-0 z-[4000] flex items-end px-4 py-6 sm:items-start sm:p-6">
        <div class="flex w-full flex-col items-center space-y-4 sm:items-end">
            <transition-group
                enter-active-class="transform ease-out duration-300 transition"
                enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
                leave-active-class="transition ease-in duration-100"
                leave-from-class="opacity-100"
                leave-to-class="opacity-0">
                <NotificationItem
                    v-for="notification in notificationStore.notifications"
                    :key="notification.id"
                    :notification="notification" />
            </transition-group>
        </div>
    </div>
</template>

<style scoped></style>
